import { assertNever } from '@varos/util-typescript';
import { ResearchShellConfig } from '../../../researchShellConfig';
import { ReportingShellContext } from '../../common';
import { InsertOverlayController } from './insertOverlaylInterface';
import { InsertOverlayAggregate } from './insertOverlayModel';
import {
    InsertOverlayControllerProps,
    InsertOverlayViewProps,
} from './insertOverlayProps';
import { ReportingShellControllerBaseConfig } from '../../../base';
import React from 'react';

export function createInsertOverlayController(
    config: ReportingShellControllerBaseConfig
): InsertOverlayController {
    const {} = config;

    return {
        useProps(context, item, props): InsertOverlayViewProps {
            const [activeTab, setActiveTab] = React.useState<'template' | 'block'>(
                'template'
            );
            const [searchValue, setSearchValue] = React.useState('');

            return {
                overlay: {
                    isOpen: props.navigator.disclosure.insert.isOpen,
                    close: {
                        button: {
                            onClick: props.navigator.disclosure.insert.onClose,
                        },
                    },
                },
                overview: {
                    field: {
                        tab: {
                            value: activeTab,
                            onChange: setActiveTab,
                        },
                        search: {
                            value: searchValue,
                            onChange: setSearchValue,
                        },
                    },
                },
            };
        },
    };
}
